import { render, staticRenderFns } from "./premium-form-endorsement.vue?vue&type=template&id=f07db67a&scoped=true&"
import script from "./premium-form-endorsement.vue?vue&type=script&lang=js&"
export * from "./premium-form-endorsement.vue?vue&type=script&lang=js&"
import style0 from "./premium-form-endorsement.vue?vue&type=style&index=0&id=f07db67a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f07db67a",
  null
  
)

export default component.exports